
const appName = 'Inside Board'

const routerList = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/s/',
    redirect: '/s/dashboard',
  },
  {
    path: '/s/',
    name: 'Sistem',
    component: () => import('@/views/system/System.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        meta: {
          title: `${appName} || Board's`
        },
        component: () => import('@/views/system/dashboard/Dashboard.vue')
      },
      {
        path: '/s/board/:team/:id/:alias/:view/:taskId?',
        name: 'Boards',
        meta: {
          title: `${appName} || Board`
        },
        component: () => import('@/views/system/boards/Board.vue')
      }
    ]
  },
  {
    path: '/a/',
    name: 'Admin',
    component: () => import('@/views/system/System.vue'),
    children: [
      {
        path: '/a/users',
        name: 'Users',
        meta: {
          title: `${appName} || Users`
        },
        component: () => import('@/views/admin/users/Users.vue')
      },
      {
        path: '/a/squads',
        name: 'Squads',
        meta: {
          title: `${appName} || Squads`
        },
        component: () => import('@/views/admin/groups/Groups.vue'),
      },
      {
        path: '/a/properties',
        name: 'Properties',
        meta: {
          title: `${appName} || Properties`
        },
        component: () => import('@/views/admin/properties/Properties.vue')
      },
      {
        path: '/a/all-boards',
        name: 'AllBoards',
        meta: {
          title: `${appName} || Todos os Board's`
        },
        component: () => import('@/views/admin/boards/Boards.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: `${appName} || Login`
    },
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    meta: {
      title: `${appName} || Logout`
    },
    component: () => import('@/views/Logout.vue')
  }
];

export default routerList